@if (canEdit() && data().has(selectedMonday())) {
  <button
          (click)="deleteWeek()"
          class="btn btn-outline-danger add-button">Remove availabilities starting from {{ selectedMonday() }}
  </button>
}
<h4>Availability</h4>
<app-week-select [selectedMonday]="selectedMonday()" [latestMonday]="lastVisibleMonday()"
                 (selectedMondayEvent)="selectWeek($event)"></app-week-select>

@if (hours().length > 0) {
  <table class="table employee-calendar-table">
    <thead>
    <tr>
      <th></th>
      @for (weekday of weekdays; track weekday) {
        <th>
          {{ weekday | dayOfWeekParse }}
          @if (canEdit() && !weekAvailabilities().has(weekday)) {
            <span>
                <button class="btn btn-secondary" (click)="editCalendarDay(weekday, EditType.CREATE)">
                  <span class="add-icon"></span>
                </button>
              </span>
          }
          <ng-container
                  *ngTemplateOutlet="template; context: {$implicit: weekAvailabilities().get(weekday)}">
          </ng-container>
        </th>
      }
    </tr>
    </thead>
    <tbody>
      @for (hour of hours(); track hour) {
        <tr>
          <td>
            <span class="hour">{{ hour | timeParse | dateFormat: 'HH:mm' }}</span>
          </td>
          @for (weekday of weekdays; track weekday) {
            <td></td>
          }
        </tr>
      }
    </tbody>
  </table>
}

<ng-template #template let-availability>
  @if (availability && availability.startTime) {
    <div
            class="available"
            appTimeSlot
            [gridStart]="hours()[0]"
            [startTime]="getStartTimeForCalendar(availability)"
            [endTime]="getEndTimeForCalendar(availability)"
            [cellHeight]="cellHeight">
      <div class="available-hours">
        {{ availability.startTime | timeParse | dateFormat: 'HH:mm' }} -
        {{ availability.endTime | timeParse | dateFormat: 'HH:mm' }}
      </div>
      @if (canEdit()) {
        <div>
          <i (click)="editCalendarDay(availability.dayOfWeek, EditType.EDIT)" class="fa fa-1x fa-cog pointer"></i>
          <i (click)="editCalendarDay(availability.dayOfWeek, EditType.DELETE)" class="fa fa-1x fa-trash pointer"></i>
        </div>
      }
    </div>
  }
</ng-template>
